// src/assets/assets.tsx

import SY from "./SY.PNG.png"
import cashapp_logo from "./cashapp_logo.png"

export const assets = {
  SY,
  cashapp_logo,
};